import React from 'react';
import { FaFacebook, FaTwitch, FaInstagram, FaLinkedin, FaYoutube, FaDiscord, FaWhatsapp, FaReddit } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { SiQuora } from 'react-icons/si';
import styles from './subscription.module.css';

const socialLinks = [
    { id: "facebook", icon: FaFacebook, url: "https://goo.su/TSZ1vD", label: "Facebook" },
    { id: "twitch", icon: FaTwitch, url: "https://twitch.tv/death_by_pixel", label: "Twitch" },
    { id: "instagram", icon: FaInstagram, url: "https://rb.gy/sxo2f9", label: "Instagram" },
    { id: "whatsapp", icon: FaWhatsapp, url: "https://wa.link/oskfd2", label: "WhatsApp" },
    { id: "youtube", icon: FaYoutube, url: "http://www.youtube.com/@PixelMoon-v9p", label: "YouTube" },
    { id: "discord", icon: FaDiscord, url: "https://discord.gg/vruwvU8Z", label: "Discord" },
    { id: "twitter", icon: FaXTwitter, url: "https://x.com/PixelMoonStores?t=UmMMSrAoFhIh1pV31VoBjQ&s=08", label: "Twitter/X" },
  { id: "quora", icon: SiQuora, url: "https://www.quora.com/profile/Pixel-Moon?ch=3&oid=3034228526&share=b6744125&srid=5nklmE&target_type=user", label: "Quora" },
  {id: 'reddit', icon: FaReddit, url: 'https://www.reddit.com/u/Pixel_Moon_Store/s/deT2rG0GFQ', label: 'Reddit'},
];


const SubscriptionSection = () => {
    return (
        <section className={styles.subscribeSection}>
            <div className={styles.banner} />
            <img
                src="./links-banner.jpeg"
                alt="Gaming Background"
                className={styles.backgroundBanner}
            />

            <img
                src="./links-front.png"
                alt="Character"
                className={styles.characterImage}
            />

            <div className={styles.contentWrapper}>
                <div className={styles.textContent}>
                    <h2 className={styles.title}>SUBSCRIBE</h2>
                    <p className={styles.subtitle}>Get The Best Deals Now!</p>

                    <div className={styles.socialIcons}>
                        {socialLinks.map((social) => {
                            const Icon = social.icon;
                            return (
                                <a
                                    key={social.id}
                                    href={social.url}
                                    className={styles.socialIcon}
                                    aria-label={social.label}
                                >
                                    <Icon className={styles.socialIconGlyph} />
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SubscriptionSection;